// extracted by mini-css-extract-plugin
module.exports = {"button":"_45b2f2b"};